<template>
  <div>
    <template v-if="showFilter">
      <div class="section-title">{{ $t('stock.filters') }}</div>
      <section class="section filter">
        <div class="row narrow-gutters">
          <div
            class="filter-row"
            :class="{ 'col-12': localSelectedCity === '', 'col-6': localSelectedCity !== '' }"
          >
            <select v-model="localSelectedCity" class="select-item">
              <option value="">{{ $t('stock.allCities') }}</option>
              <option v-for="city in cities" :value="city.idx" :key="city.idx">
                {{ city.name }}
              </option>
            </select>
          </div>
          <div class="col-6 filter-row" v-if="localSelectedCity !== ''">
            <select v-model="localSelectedBranch" class="select-item">
              <option value="">{{ $t('stock.allBranches') }}</option>
              <option v-for="branch in branches" :value="branch.idx" :key="branch.idx">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row narrow-gutters">
          <div class="col-12">
            <select v-model="localSelectedRewards" class="select-item">
              <option value="">{{ $t('stock.allItems') }}</option>
              <option v-for="product in rewardsOptions" :value="product.title" :key="product.idx">
                {{ product.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-tools row narrow-gutters">
          <div class="col-6">
            <button class="btn btn-lg btn-block btn-secondary" @click="handleReset">{{ $t('common.cancel') }}</button>
          </div>
          <div class="col-6">
            <button class="btn btn-lg btn-block btn-primary" @click="handleSubmit">{{ $t('common.submit') }}</button>
          </div>
        </div>
      </section>
    </template>
    <template v-else>
      <section class="section tool-container justify-content-end">
        <a
          class="filter-btn"
          v-on:click="showFilter = true"
        >
          {{ $t('stock.filters') }}
        </a>
      </section>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StockFilter',
  props: {
    cities: {
      type: Array,
      default: () => [],
    },
    branches: {
      type: Array,
      default: () => [],
    },
    rewardsOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showFilter: false,
      localSelectedCity: '',
      localSelectedBranch: '',
      localSelectedRewards: '',
    };
  },
  watch: {
    localSelectedCity(val) {
      if (!val) {
        this.localSelectedBranch = '';
      }
      this.$emit('change-city', val);
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', {
        city: this.localSelectedCity,
        branch: this.localSelectedBranch,
        rewards: this.localSelectedRewards,
      });
    },
    handleReset() {
      this.localSelectedCity = '';
      this.localSelectedBranch = '';
      this.localSelectedRewards = '';
      this.showFilter = false;
      this.$emit('reset');
    },
  },
};
</script>

<style lang="sass" scoped>
.section-title
  margin: 24px 24px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

  & + .section
    margin-top: 0

  &-container
    display: flex
    align-items: center
    margin: 24px 24px 8px

    & + .section
      margin-top: 0

    .section-title
      flex-grow: 1
      margin: 0

.select-item
  width: 100%
  padding: 10px 15px

  border: none
  border-radius: 23px

  background-color: #f5f5f5
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
  background-size: 24px
  background-repeat: no-repeat
  background-position: right center

  color: #333

  -webkit-padding-end: 24px
  appearance: none
  text-overflow: ellipsis
  white-space: nowrap

  &:disabled
    opacity: 1

    background-image: none

  &__container
    height: 44px

    border-radius: 23px 0 0 23px

    background-color: white

  &::after
    content: ''

  &:focus
    outline: none

.view--stock
  width: 100%
  height: 100%
  position: relative

  .btn
    border: none

.btn
  box-shadow: none
  padding: 6px 16px
  display: block
  border-radius: 99px
  background-color: #ffea00

  color: #333
  font-weight: bold
  font-size: 1.125em

  outline: none

  &:active
    opacity: .5
    transform: scale(.95)
.tool-container
  margin: 24px 16px 0
  display: flex

.filter
  padding: 0 16px 24px

  &-btn
    padding: 8px 16px
    display: inline-block

    border-radius: 10px

    background: #f5f5f5

    text-align: center
    font-size: 0.75rem
    font-weight: bold
    color: #8E8E8E

    cursor: pointer
    appearance: none

  &-row
    margin: 8px 0

  &-tools
    margin-top: 16px
</style>
